import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  buttonCont: {
    marginTop: theme.spacing(8),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  appBar: {
    width: '100%',
    background: 'inherit',
    boxShadow: 'none',
    marginBottom: 30,
  },
  tabs: {
    background: 'inherit',
    border: 0,
    borderRadius: 3,
    height: 48,
    padding: '0 30px',
    color: 'white',
    paddingLeft: 0,
  },
  button: {
    '&:hover': {
      border: 'none',
    },
  },
  tab: {
    '&:hover': {
      border: 0,
      outline: 'none',
    },
    '&:focus': {
      border: 0,
      outline: 'none',
    },
  },
  link: {
    textDecoration: 'none',
  },
  search: {
    width: '40%',
    minWidth: 200,
  },
  mobileContainer: {
    [theme.breakpoints.down('sm')]: { marginBottom: '24px' },
  },
  nameCell: {
    width: '50%',
    padding: 8,
    wordBreak: 'break-word',
  },
  phoneCell: {
    width: '50%',
    padding: 8,
    wordBreak: 'break-word',
  },
}));

export default useStyles;
